import React, { useContext, useState, useEffect } from 'react'
import { CheckboxContext } from './checkbox-context'
import { getState, isIndeterminate } from '../utils'
import { CheckboxIndicatorContainer } from '../styled-components'

const CheckboxIndicator = React.forwardRef((props, forwardedRef) => {
  const { forceMount, ...indicatorProps } = props
  const context = useContext(CheckboxContext)

  const [isPresent, setIsPresent] = useState(forceMount)

  useEffect(() => {
    /**
     * Used to force mounting when more control is needed. Useful when
     * controlling animation with React animation libraries.
     */
    setIsPresent(
      forceMount || isIndeterminate(context.state) || context.state === true
    )
  }, [forceMount, context.state])

  return (
    isPresent && (
      <CheckboxIndicatorContainer
        size={context.size}
        data-state={getState(context.state)}
        data-disabled={context.disabled ? '' : undefined}
        {...indicatorProps}
        ref={forwardedRef}
        style={{ pointerEvents: 'none', ...props.style }}
      />
    )
  )
})

CheckboxIndicator.displayName = 'CheckboxIndicator'
export default CheckboxIndicator
